import Login from '@views/Login';


export const unauthenticatedRoutes = [
    {
        path: '/login',
        component: Login
    }
]